import { userConstants } from '../redux-constants'

const initialState = {
    error: null,
    loading: false,
    profile: null,
    checkAuthDone: false,
}

export default function user(state = initialState, action) {
    switch (action.type) {
        case userConstants.AJAX_CALL_REQUEST:
            state.loading = true
            state.error = null
            return state
        case userConstants.LOGOUT_REQUEST:
            state.checkAuthDone = false
            state.loading = true
            state.error = null
            return state
        case userConstants.AJAX_CALL_FAILURE:
            state.error = action.payload
            state.loading = false
            state.checkAuthDone = true
            return state
        case userConstants.AJAX_CALL_SUCCESS:
            state.loading = false
            state.checkAuthDone = true
            return state
        case userConstants.LOGOUT_SUCCESS:
            state.loading = false
            state.profile = null
            state.checkAuthDone = true
            return state
        case userConstants.UPDATE_USER:
            state.profile = action.payload
            state.checkAuthDone = true
            return state
        case userConstants.CHECK_USER_AUTH_DONE:
            state.checkAuthDone = true
            return state
        case userConstants.VERIFY_EMAIL_SUCCESS:
            state.loading = false
            state.error = null
            state.profile = { ...state.profile, emailVerified: true }
            state.checkAuthDone = true
            return state
        default:
            return state
    }
}
